import { FlightReservation } from "@/types/flightReservation";
import { getGlobalSessionId, ecsClient } from "@/services";
import { FlightDelayNotice } from "@/types/flightDelayNotice";

export type FlightReservationWithDelayNotice = FlightReservation & {
  delayNotice: FlightDelayNotice | null;
};

export type GetUserFlightReservationsResponse = {
  success: boolean;
  message: string;
  reservations: FlightReservationWithDelayNotice[];
  totalCount: number;
};

type FlightReservationAnalysisResponse = {
  success: boolean;
  message: string;
  analysis: any;
};

type DeleteFlightReservationResponse = {
  success: boolean;
  message: string;
  reservation: FlightReservation;
};

const FlightReservationServices = {
  getReservations: async () => {
    const sessionId = getGlobalSessionId();

    const result = await ecsClient.get<GetUserFlightReservationsResponse>(
      "/flight",
      {
        params: { sessionId },
      }
    );

    return result.data?.reservations || [];
  },

  analyzeUserEmailForFlightReservations: async (userId: string) => {
    const result = await ecsClient.post<FlightReservationAnalysisResponse>(
      "/flight/analyze",
      {
        userId,
      }
    );

    return result.data;
  },

  deleteFlightReservation: async (confirmationNumber: string) => {
    const sessionId = getGlobalSessionId();

    const result = await ecsClient.delete<DeleteFlightReservationResponse>(
      "/flight",
      {
        data: {
          sessionId: sessionId!,
          confirmationNumber: confirmationNumber,
        },
      }
    );

    return result.data;
  },
};

export default FlightReservationServices;
